export default {"src":"/_next/static/media/link-primary.6b36bc35.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};